<template>
	<el-container>
		<div class="container">
			<el-container>
				<el-aside width="240px">
					<div class="logo">数据采集平台</div>
					<el-menu
						:default-active="defaultActive"
						class="el-menu-vertical-demo"
						router
						@open="handleOpen"
						@close="handleClose"
						background-color="#fff"
					>
						<template v-for="(item, index) in menuList">
						<el-submenu :index="index + ''" :key="index + ''">
							<template slot="title">
							<!-- <i class="el-icon-menu"></i> -->
							<span>{{ item.resourcesName }}</span>
							</template>
							<el-menu-item
							v-for="child in item.children"
							:index="child.resourcesUrl"
							:key="child.resourcesUrl"
							v-if="child.type == 2"
							>
							{{ child.resourcesName }}
							</el-menu-item>
							<el-submenu
							v-for="(child, index2) in item.children"
							:index="index + '' + index2"
							:key="index + '' + index2"
							v-if="child.type == 0"
							>
							<template slot="title">{{ child.resourcesName }}</template>
							<el-menu-item
								:index="son.resourcesUrl"
								:key="son.resourcesUrl"
								v-for="son in child.children"
								>{{ son.resourcesName }}
							</el-menu-item>
							</el-submenu>
						</el-submenu>
						</template>
					</el-menu>
					</el-aside>
					<el-main>
					<div class="content-top">
						<div class="sign-out">
						<el-dropdown>
							<span class="el-dropdown-link"
							>{{ userName
							}}<i class="el-icon-arrow-down el-icon--right"></i
							></span>
							<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="open"
								>退出登录</el-dropdown-item
							>
							</el-dropdown-menu>
						</el-dropdown>
						</div>
					</div>
					<div class="content-container">
						<transition v-if="view" name="fade" mode="out-in">
							<router-view></router-view>
						</transition>
					</div>
				</el-main>
			</el-container>
		</div>
		<!--登出提示-->
		<dialog-tips
		:show.sync="show"
		content="确认退出吗?"
		@getCancel="show = false"
		@getConfirm="handleConfirm"
		>
		</dialog-tips>
	</el-container>
</template>

<script>
import { Logout, getModuleMenu } from "@/apis/login";
import DialogTips from "../components/dialogTips";
export default {
	components: { DialogTips },
	data() {
		return {
			userName: "",
			show: false, // 弹出登出提示
			view: false,
			menuList: [],
			menuPageList: [],
			methodList: {},
			defaultActive: this.$route.path
		};
	},
	watch: {
		menuPageList: {
			handler() {
				let { path } = this.$route;
				if (!this.menuPageList.includes(path)) {
				path = this.menuPageList[0] || path;
				// this.$router.push({ path });
				}
				this.defaultActive = path;
			},
			immediate: true,
			deep: true
		}
	},
	mounted() {
		const user = this.$storage.get("user");
		let showValue = "万顺叫车";
		if (user) {
			this.userName = user.userName || "";
			this.token = user.token || "";
			showValue = `${user.userName} ${user.loginTime}`;
			this.getModuleMenuFun();
			// this.getProvinceCityList();
		}
		this.$watermark.set(showValue);
	},
	methods: {
		// 查询菜单接口
		async getModuleMenuFun() {
			const params = {
				token: this.token, // 必传token
				data: {
					moduleName: "数据采集平台"
				}
			};
			params.data = JSON.stringify(params.data);
			try {
				const data = await getModuleMenu(params);
				if (data.code == 1) {
					this.view = true;
					this.menuList = JSON.parse(data.data);
					this.menuList = this.menuList.filter(
						item => item.resourcesName !== "通用模块配置"
					);
					this.menuPageList = [];
					this.dfsTraversalData(this.menuList);
					this.$storage.setSession("methodList", this.methodList);
				}
			} catch (error) {}
		},
		dfsTraversalData(menuData) {
			for (const item of menuData) {
				// type 0：无页面菜单，1：功能菜单（方法）2：有页面菜单
				if (item.type == 1) {
					continue;
				}
				if (item.type == 2) {
					this.menuPageList.push(item.resourcesUrl);
					item.children &&
						this.getMethodList(this.getPath(item), item.children);
					}
				if (item.children) {
					this.dfsTraversalData(item.children);
				}
			}
		},
		getMethodList(path, data) {
			const methodList = {};
			for (const item of data) {
				if (!item.children) {
					continue;
				}
				for (const child of item.children) {
					methodList[child.op] = {
						resourcesName: child.resourcesName,
						resourcesUrl: this.getPath(child)
					};
				}
			}
			this.methodList[path] = methodList;
		},
		getPath(item) {
			let path = item.resourcesUrl || "";
			if (path && !path.startsWith("/")) {
				path = `/${path}`;
			}
			return path;
		},
		handleOpen(key, keyPath) {},
		handleClose(key, keyPath) {},
		// 弹出层确定事件登出
		open() {
			this.show = !this.show;
		},
		handleConfirm() {
			this.logOut();
			this.show = !this.show;
		},
		// 退出登录
		async logOut() {
			try {
				const data = await Logout({
					token: this.token
				});
				if (data.code == 1) {
					this.$storage.remove("user");
					this.$watermark.remove();
					await this.$router.push("/login");
				} else {
					this.$message({
						message: data.msg,
						type: "error"
					});
				}
			} catch (error) {
				console.log(error);
			}
		}
	}
};
</script>

<style scoped lang="scss">
	.logo {
		color: #f05259;
		font-size: 25px;
		height: 100px;
		line-height: 100px;
		text-align: center;
		background: #fff;
		border-right: 1px solid #e6e6e6;
	}

	.content-top {
		height: 60px;
		width: 100%;
		background: #fff;
		box-shadow: 0px 10px 10px -10px rgba($color: #999, $alpha: 0.3);
		display: flex;
		justify-content: flex-end;

		.sign-out {
			padding: 0 30px;
			height: 30px;
			margin-top: 20px;
		}
	}

	.el-main {
		padding: 0;
	}

	.el-dropdown-link {
		cursor: pointer;
		color: #333;
	}

	.el-icon-arrow-down {
		font-size: 12px;
	}

	.el-header {
		background-color: #fff;
		color: #333;
		line-height: 60px;
	}

	.el-aside {
		background-color: #fff;
		color: #333;
		line-height: 200px;
		height: 100%;
		display: flex;
		flex-direction: column;
	}

	.container {
		display: flex;
		position: absolute;
		top: 0;
		bottom: 0px;
		overflow: hidden;
		width: 100%;
	}

	.content-container {
		padding: 20px;

	i {
		float: right;
		font-style: normal;
	}
	}

	.el-menu-vertical-demo {
		flex: 1;
	}

	.el-menu-vertical-demo > .el-submenu.is-active /deep/ .el-submenu__title {
		background-color: rgb(254, 238, 238) !important;
	}

	.el-menu-vertical-demo > .el-submenu.is-active .el-menu-item,
	.el-menu-vertical-demo
	> .el-submenu.is-active
	/deep/
	.el-submenu
	> .el-submenu__title {
		background-color: #fff !important;
	}

	.el-menu-vertical-demo > .el-submenu.is-active .el-menu-item.is-active {
		background: rgb(254, 238, 238) !important;
	}

	// .el-menu-vertical-demo > .el-submenu.is-active /deep/ .el-submenu > .el-menu--inline .el-menu-item{
	//   background-color: #fff !important;
	// }
	.el-menu-vertical-demo
	> .el-submenu.is-active
	/deep/
	.el-submenu
	> .el-menu--inline
	.el-menu-item.is-active {
		background: rgb(254, 238, 238) !important;
	}
</style>
